<template>
  <div class="clock-widget notes">
    <div class="notes-header">
      <button type="button" @click="closeNotes">
        <img src="../../../images/arrow-black-small.svg" alt="Note" />
      </button>
      <span>{{ label.get("notes") }}</span>
    </div>
    <div class="notes-content">
      <textarea
        :placeholder="label.get('type_your_notes_here')"
        v-model="noteText"
        maxlength="500"
      ></textarea>
      <button type="button" @click="saveNotes" :disabled="disabledButton">
        <div v-if="disabledButton" class="btn-loader" />
        <span v-if="!disabledButton">{{ label.get("add_notes") }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import TimesheetService from "../timesheets/shared/TimesheetService";

export default {
  name: "NotesWidgetComponent",
  props: {
    timesheetId: {
      type: Number,
      default: null,
    },
    note: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      noteText: this.note,
      disabledButton: false,
    };
  },
  methods: {
    closeNotes() {
      this.$emit("onNotesClose");
    },
    saveNotes() {
      this.disabledButton = true;
      TimesheetService.addTimesheetNote({
        timesheet_id: this.timesheetId,
        note: this.noteText,
      })
        .then(() => {
          this.$emit("onNotesClose", this.noteText);
        })
        .catch(() => {
          this.disabledButton = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.clock-widget.notes {
  position: absolute;
  top: 0;
  left: 0;
  height: 520px;
  .notes-header {
    display: flex;
    align-items: center;
    width: 100%;
    height: 73px;
    background: #fafafa;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom: 1px solid #efefef;
    padding: 27px;
    span {
      margin-left: 12px;
      font-size: 1.25rem;
      line-height: 1.75rem;
      font-weight: 500;
      color: #262626;
      text-transform: capitalize;
    }
  }
  .notes-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: calc(100% - 73px);
    padding: 10px 24px 40px 24px;
    background: #fff;
    z-index: 5;
    textarea {
      width: 100%;
      height: 80%;
      border: none;
      overflow: auto;
      outline: none;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
      resize: none;
      padding: 0;
      font-size: 0.875rem;
      line-height: 1.75rem;
      color: #000000;
      &::placeholder {
        font-size: 0.875rem;
        line-height: 1.75rem;
        color: #666666;
      }
    }
    button {
      width: 100%;
      height: 48px;
      border-radius: 4px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      background: #00b9cb;
      &:hover {
        background: #0a9ead;
      }
      span {
        font-size: 1.125rem;
        color: #ffffff;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
}
.time-clock-container.with-header {
  .notes-content {
    height: 620px;
  }
}
</style>
